import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Login } from "./Login";
import "./styles.css";

const loginRoute = window.location.pathname === "/login" || window.location.pathname === "/login/";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {loginRoute ? <Login /> : <App />}
  </React.StrictMode>,
);
